const config = {
    projectName: 'Wisper CMS Australia',
    menuVersion: 'V2',
}

export {
    config,
}